import { emptyArray } from 'ui-components/default-props/empty';
import isEmpty from 'lodash.isempty';
import Global from '../store/global-selectors';

class ShipTogetherHelperServiceClass {
  shipTogetherOrderMeta(fulfillmentPlansToCombine = emptyArray, salesOrders = emptyArray) {
    let combinedTotalItemQuantity = 0;
    let shipTogetherItems = [];
    const fulfillmentPlanIdsWithoutItems = [];
    const fulfillmentPlansWithCombineDetails = [];

    fulfillmentPlansToCombine.forEach((originalFulfillmentPlan) => {
      if (isEmpty(originalFulfillmentPlan)) {
        return;
      }

      // spread the original fulfillment plan props, so we don't actually mutate the original
      const fulfillmentPlanWithOrderDetails = { ...originalFulfillmentPlan };

      const firstFulfilledSalesOrderId = fulfillmentPlanWithOrderDetails?.salesOrdersFulfilledIds?.[0] ?? '';
      const firstFulFilledSalesOrder = salesOrders.find((x) => x?.salesOrderId === firstFulfilledSalesOrderId);
      if (firstFulFilledSalesOrder) {
        const { salesOrderId, orderNumber, store } = firstFulFilledSalesOrder;
        fulfillmentPlanWithOrderDetails.salesOrderId = salesOrderId;
        fulfillmentPlanWithOrderDetails.orderNumber = orderNumber;
        fulfillmentPlanWithOrderDetails.marketplaceId = store.marketplaceId;
      }

      const { fulfillmentPlanId, items } = fulfillmentPlanWithOrderDetails;

      let fulfillmentPlanQuantityOrdered = 0;

      if (items && items.length) {
        fulfillmentPlanQuantityOrdered = items.reduce((acc, fulfillmentPlanItem) => acc + (fulfillmentPlanItem.quantity || 0), 0);
        const fulfillmentPlanShipTogetherItems = items.map((fulfillmentPlanItem) => {
          const salesOrderForItem = salesOrders.find((salesOrder) =>
            salesOrder.items?.some((item) => item.salesOrderItemId === fulfillmentPlanItem.salesOrderItemId),
          );

          return {
            ...fulfillmentPlanItem,
            fulfillmentPlanId,
            salesOrderId: salesOrderForItem?.salesOrderId,
          };
        });
        shipTogetherItems = [...shipTogetherItems, ...fulfillmentPlanShipTogetherItems];
      } else {
        fulfillmentPlanIdsWithoutItems.push(fulfillmentPlanId);
      }

      fulfillmentPlanWithOrderDetails.totalItemQuantity = fulfillmentPlanQuantityOrdered;
      combinedTotalItemQuantity += fulfillmentPlanQuantityOrdered;
      fulfillmentPlansWithCombineDetails.push(fulfillmentPlanWithOrderDetails);
    });

    return {
      fulfillmentPlansWithCombineDetails,
      combinedTotalItemQuantity,
      shipTogetherItems,
      fulfillmentPlanIdsWithoutItems,
    };
  }

  getShipTogetherSelectedOrders(state, fulfillmentPlanIds) {
    const salesOrders = Global.selectEntitiesSalesOrdersByFulfillmentPlanIds(state, { fulfillmentPlanIds });
    return salesOrders.reduce((acc, so) => {
      if (so.fulfillmentPlanIds.length) {
        const fulfillmentPlansList = Global.selectEntitiesFulfillmentPlansBySalesOrderIds(state, {
          salesOrderIds: [so.salesOrderId],
        });
        acc.push({ salesOrder: so, fulfillmentPlans: fulfillmentPlansList });
        return acc;
      }
      acc.push({ salesOrder: so, fulfillmentPlans: [] });
      return acc;
    }, []);
  }
}

export const ShipTogetherHelperService = new ShipTogetherHelperServiceClass();
